<!-- static content data from lang: questionnaire-questions -->
<template>
    <div>
        <base-header class="pb-6" v-loading="loading">
            <div class="row align-items-center pb-4">
                <div class="col-lg-12 col-12">
                    <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
                    <nav aria-label="breadcrumb" class="d-inline-block ml-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
                <div>
                    <div class="col-md-12">
                        <FlashMessages > </FlashMessages>
                      <template v-for="(message) in alertMessages">
                        <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                      </template>
                      <template v-for="(message) in successMessages">
                        <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                      </template>
                        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                            <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input
                                                    :label="lang.label.questionnaires"
                                                    name="questionnaire"
                                                    :rules="{required: true}"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    >
                                                    <el-select v-model="model.questionnaire" autocomplete="off" ref="questionnaire" @change="getQuestions" filterable>
                                                        <el-option
                                                            v-for="option in questionnaire"
                                                            :key="option.ID"
                                                            :label="option.Name"
                                                            :value="option.ID"
                                                            ></el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <!--                                            <div class="col-lg-6">
                                                                                            <div class="form-group">
                                                                                                <label class="form-control-label d-none d-lg-block">&nbsp;</label>
                                                                                                <base-button type="primary" @click.native="showSwal()">{{lang.label.buttons.delete}}</base-button>
                                                                                            </div>
                                                                                        </div>-->
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </validation-observer>
                    </div>
                    <hr class="mt-0" />
                    <!-- <div class="col-12 text-right mb-3">
                      <base-button type="primary" @click="addClick()">{{lang.label.buttons.add}}</base-button>
                    </div>-->
                    <div class="col-12 text-center text-lg-left">
                        <div class="row">
                            <div
                                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                                >
                                <el-select
                                    class="select-primary pagination-select"
                                    autocomplete="off"
                                    v-model="pagination.perPage"
                                    placeholder="Per page"
                                    >
                                    <el-option
                                        class="select-primary"
                                        v-for="item in pagination.perPageOptions"
                                        :key="item"
                                        :label="item"
                                        :value="item"
                                        ></el-option>
                                </el-select>

                                <div>
                                    <base-input
                                        v-model="searchQuery"
                                        autocomplete="off"
                                        prepend-icon="fas fa-search"
                                        :placeholder="lang.label.search"
                                        ></base-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                            border
                            >
                            <el-table-column type="selection" prop="checked">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.checked" :disabled="scope.row.disabled" ></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column width="220px" label="Question Sequence Number" prop="SequenceNumber" sortable>
                                <template slot-scope="scope">
                                    <div class="col-number">
                                        <base-input @keypress="isNumber($event)" :ref="'value'+ scope.$index" v-model="scope.row.SequenceNumber" autocomplete="off" ></base-input>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="160px" label="Question" sortable prop="Name">
                                <div class="d-flex" slot-scope="scope" v-html="scope.row.Name"></div>
                            </el-table-column>
                            <el-table-column
                                width="150px"
                                label="Default"
                                prop="DefaultValueType"
                                sortable
                                >
                                <template slot-scope="scope">
                                    <div>
                                    <base-switch class="mr-1" v-model="scope.row.DefaultValueType" on-text="Yes" off-text="No"></base-switch>
                                    <!--  <base-input
                                        name="questionnaireOptions"
                                      >
                                        <el-select v-model="scope.row.DefaultValueType" autocomplete="off" filterable>
                                          <el-option
                                            v-for="option in questionnaireOptions"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.value"
                                          ></el-option>
                                        </el-select>
                                      </base-input> -->
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="150px"
                                label="Questionnaire Questions"
                                prop="DisqualifyingValueType"
                                sortable
                                >
                                <template slot-scope="scope">
                                    <div>
<!--                                        <base-switch class="mr-1" v-model="scope.row.DisqualifyingValueType" on-text="Yes" off-text="No"></base-switch>-->
                                      <base-input
                                        name="questionnaireOptions"
                                      >
                                        <el-select v-model="scope.row.DisqualifyingValueType" autocomplete="off" filterable>
                                          <el-option
                                            v-for="option in questionnaireOptions"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.value"
                                          ></el-option>
                                        </el-select>
                                      </base-input>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div
                    class="col-12 mt-3 d-flex justify-content-center justify-content-sm-between flex-wrap"
                    >
                    <div class>
                        <p class="card-category">
                            {{lang.label.showPagination.showing}} {{ from + 1 }} {{lang.label.showPagination.to}} {{ to }} {{lang.label.showPagination.of}} {{ total }} {{lang.label.showPagination.entries}}
                            <span
                                v-if="selectedRows.length"
                                >&nbsp; &nbsp; {{selectedRows.length}} {{lang.label.showPagination.rowsSelected}}</span>
                        </p>
                    </div>
                    <base-pagination
                        class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                        ></base-pagination>
                </div>
                <div class="col-12 text-right mb-3">
                    <base-button type="primary" native-type="submit" @click="onSubmit">{{lang.label.buttons.save}}</base-button>
                </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
    import { Table, TableColumn, Select, Option, Checkbox } from "element-ui";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import { BasePagination } from "@/components";
    import clientPaginationMixin from "../../Tables/PaginatedTables/clientPaginationMixin";
    import swal from "sweetalert2";
    import Vue from 'vue';
    import "sweetalert2/dist/sweetalert2.css";
    import flatPicker from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import Alert from "@/components/BaseAlert.vue";
    import FlashMessages from "@/views/GeneralViews/flash-message.vue";

    export default {
        mixins: [clientPaginationMixin],
        components: {
            BasePagination,
            RouteBreadCrumb,
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            flatPicker,
            [Checkbox.name]: Checkbox,
            Alert,
            FlashMessages
        },
        data() {
            return {
                alertType: 'danger',
                successType: 'success',
                alertMessages: [],
                successMessages: [],
                questionnaireOptions: [
                    {ID:1,Name: 'No',value: 0},
                    {ID:2,Name: 'Yes',value: 1},
                    {ID:3,Name: 'N/A',value: 2},
                ],
                sequence: [],
                originalQuestions: [],
                includedQuestionIds: [],

                filterdArray: [],
                loading: true,
                lang: this.$lang.questionnaire_questions,
                propsToSearch: ["SequenceNumber", "Name"],
                model: {
                    questionnaire: ""
                },
                selects: {
                    simple: "Select"
                },
                questionnaire: [],
                selectedindex: 0,
                tableColumns: [],
                tableData: [],
                tempData: [],
                pagination: {
                    perPage: 50
                },
                questionnaireData: [],
                selectedRows: [],
                switches: {
                    off: false,
                    on: true
                },
                showSwal() {
                    swal
                            .fire({
                                title: "Are you sure?",
                                text: "Do you really want to delete this record? Deleting this will also delete it's corresponding child data as well.",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonText: "Yes, delete it!",
                                cancelButtonText: "No, keep it",
                                buttonsStyling: false,
                                customClass: {
                                    confirmButton: "btn btn-primary btn-fill",
                                    cancelButton: "btn btn-danger btn-fill"
                                }
                            }).then(result => {
                        if (result.value) {
                        } else if (result.dismiss === swal.DismissReason.cancel) {
                        }
                    });
                }
            };
        },
        mounted() {
            this.$store.dispatch('siteQuestionnairesList').then(response => {
                console.log(response.data)
                if (response.data && response.data.length) {
                    this.questionnaire = response.data;
                }
                this.loading = false;
            });
        },
        methods: {
            isNumber: function (index, evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                }
            },
            getQuestions(id) {
                let self = this;
                this.loading = true;
                var tableobject = {
                    Name: "",
                    checked: true,
                    SequenceNumber: 0,
                    DefaultValueType: false,
                    DisqualifyingValueType: 2
                };
                this.tableData = [];
                this.includedQuestionIds = [];
                this.$store.dispatch('questionnaireQuestions', id).then(response => {
                    this.questionnaireData = response;
                    let tempTableData = [];
                    this.questionnaireData.forEach((object, index) => {
                        tableobject = {};
                        if (object.CompanyQuestionnaireQuestionID > 0) {
                            this.includedQuestionIds.push(object.ID);
                            this.tempData[object.ID] = object;
                        }
                        if (object.Is_Locked) {
                            tableobject.checked = true;
                            tableobject.disabled = true;
                        }
                        tableobject.CompanyQuestionnaireQuestionID = object.CompanyQuestionnaireQuestionID;
                        tableobject.CompanyQuestionnaireID = object.CompanyQuestionnaireID;
                        tableobject.Name = object.Name;
                        tableobject.ID = object.ID;
                        tableobject.DefaultValueType = (object.DefaultValueType == null || object.DefaultValueType == "" || object.DefaultValueType == 0 || object.DefaultValueType == false) ? false : true;
                        tableobject.SequenceNumber = object.SequenceNumber ? object.SequenceNumber : index;
                        tableobject.Code = object.Code;
                        tempTableData.push(tableobject);
                    });
                    var selectedObj = {};
                    let tableObj = {
                        checked: false,
                        SequenceNumber: 0,
                        DefaultValueType: false,
                        DisqualifyingValueType: 2,
                    };
                    tempTableData.forEach((object, index) => {
                        tableObj = {};
                        if (this.includedQuestionIds.includes(object.ID)) {
                            selectedObj = this.tempData[object.ID];
                            tableObj.checked = true;
                            // self.tableData[index].checked = true;
                            self.questionnaireData[index].checked = true;
                            // self.tableData[index].SequenceNumber = selectedObj['SequenceNumber'];
                            tableObj.SequenceNumber = selectedObj['SequenceNumber'];
                            tableObj.DisqualifyingValueType = (selectedObj['DisqualifyingValueType'] == 1) ? 1 :((selectedObj['DisqualifyingValueType'] == 0)?  0 : 2);
                        } else {
                            tableObj.DisqualifyingValueType = 2;
                            tableObj.SequenceNumber = index + 1;
                            if (!object.disabled) {
                                tableObj.checked = false;
                                self.questionnaireData[index].checked = false;
                            }
                        }
                        tableObj.Code = object.Code;
                        tableObj.CompanyQuestionnaireID = object.CompanyQuestionnaireID;
                        tableObj.CompanyQuestionnaireQuestionID = object.CompanyQuestionnaireQuestionID;
                        tableObj.ID = object.ID;
                        tableObj.DefaultValueType = (object.DefaultValueType == null || object.DefaultValueType == "" || object.DefaultValueType == 0 || object.DefaultValueType == false) ? false : true;
                        tableObj.Name = object.Name;
                        this.tableData.push(tableObj);
                    });
                    this.loading = false;
                });
            },
            selectionChange(selectedRows) {
                this.selectedRows = selectedRows;
                if (selectedRows.length) {
                    selectedRows.forEach((object, index) => {
                        Vue.set(this.tableData[index], 'checked', true);
                    })
                } else {
                    let tempData = this.tableData.slice();
                    tempData.forEach((object, index) => {
                        Vue.set(this.tableData[index], 'checked', false);
                    })
                }
            },
            addClick() {
                this.$router.push({path: "add"});
            },
            onSubmit() {
                let self = this;
                if (this.model.questionnaire == '') {
                    this.$refs.questionnaire.focus();
                    this.$refs.questionnaire.blur();
                    return false;
                }
                this.loading = true;
                let createdArray = [];
                let updatedArray = [];
                let deletedArray = [];
                this.tableData.forEach((object, index) => {
                    if (!this.questionnaireData[index].checked && object.checked && this.questionnaireData[index].CompanyQuestionnaireID == '') {
                        createdArray.push({
                            "CompanyQuestionnaireID": this.model.questionnaire,
                            "CompanyQuestionsID": object.ID, //ID
                            "DisqualifyingValueType": object.DisqualifyingValueType,
                            "DefaultValueType": (object.DefaultValueType) ? 1 : 0,
                            "SequenceNumber": parseInt(object.SequenceNumber)
                        });
                    } else if (this.questionnaireData[index].checked && !object.checked && this.questionnaireData[index].CompanyQuestionnaireID > 0) {
                        deletedArray.push({
                            "ID": object.CompanyQuestionnaireQuestionID
                        })
                    } else if (this.questionnaireData[index].checked == object.checked && this.questionnaireData[index].CompanyQuestionnaireID > 0) {
                        updatedArray.push({
                            "ID": object.CompanyQuestionnaireQuestionID,
                            "CompanyQuestionnaireID": object.CompanyQuestionnaireID,
                            "CompanyQuestionsID": object.ID,
                            "DisqualifyingValueType": object.DisqualifyingValueType,
                            "DefaultValueType": (object.DefaultValueType) ? 1 : 0,
                            "SequenceNumber": parseInt(object.SequenceNumber)
                        });
                    }
                });
                let data = {};
                if (createdArray.length) {
                    data.create = createdArray;
                }
                if (updatedArray.length) {
                    data.update = updatedArray;
                }
                if (deletedArray.length) {
                    data.delete = deletedArray;
                }
                this.$store.dispatch('CUDQuestionnaireQuestion', data).then(response => {
                    if (response.status == 200) {
                        this.successMessages.push(response.data.message);
                        this.tableData = [];
                        this.model.questionnaire = '';
                        this.type = "primary";
                        this.$refs.formValidator.reset();
                        this.loading = false;
                    } else {
                        if(typeof response.data.message != 'object'){
                            this.alertMessages.push(response.data.message);
                        }else{
                            let array = new Array();
                            for (let key of Object.keys(response.data.message[0])) {
                                let obj = response.data.message[0][key][0].includes('field') ? (key+"- "+response.data.message[0][key][0]) : response.data.message[0][key];
                                array.push(obj)
                            }
                            this.alertMessages.push(array.join(', '));
                        }
                        this.loading = false;
                        setTimeout(function () {
                            self.alertMessage = '';
                        },3000);
                    }
                });
            }
        }
    };
</script>

<style>
    .no-border-card .card-footer {
        border-top: 0;
    }
    .modal-header {
        padding-bottom: 0;
    }
</style>
